import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { HeroV3 } from "@/components/site/v3/HeroV3";
import { StoryScroll } from "@/components/site/v3/StoryScroll";
import { IntentHub } from "@/components/site/IntentHub";
import { UpcomingEvents } from "@/components/site/UpcomingEvents";
import { Programs } from "@/components/site/Programs";
import { GalleryMasonry } from "@/components/site/GalleryMasonry";
import { News } from "@/components/site/News";
import { FinalCTA } from "@/components/site/FinalCTA";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function HomeV3() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay />
      <main id="content" tabIndex={-1} className="outline-none">
        <HeroV3 />
        <StoryScroll />
        <IntentHub />
        <UpcomingEvents />
        <Programs />
        <GalleryMasonry />
        <News />
        <FinalCTA />
      </main>
      <SiteFooter />
    </>
  );
}
